import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colSpan: {
          "0:0": 2,
        },
        rowsSize: [2, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/free-field-image.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    formatter: "html",
                    data:
                      "<b>Description</b></br></br>There is only one path of the sound wave from the loudspeaker to the listener, the direct sound (in red). There are no other reflections (from the floor or other obstacles). The sound examples are very dry and without any reverberance since there are no reflections, not even from the floor.",
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/free-field-chart.svg`,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/free-field-voice.wav`,
      text: "Voice",
      icon: "cil-volume",
      shape: "round",
    },
  },
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/free-field-drums.wav`,
      text: "Drums",
      icon: "cil-volume",
      shape: "round",
    },
  },
];
